
import Vue from 'vue';
import { isMobileOnly } from 'mobile-device-detect';
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { IOrder } from '../../models/orders';
import Create from './Create.vue';
import Review from './Review.vue';
import Share from './Share.vue';
import CreateBoost from './Boost/CreateBoost.vue';
import { ORDER_TYPES } from '~/pages/dashboard/settings-models/constants';

export default Vue.extend({
  name: 'CreateOrderModal',
  components: {
    Create,
    Review,
    Share,
    CreateBoost,
  },
  props: {
    duplicateOrder: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ORDER_TYPES,
      active: 'create',
      create: false,
      review: false,
      share: false,
      order: null as IOrder | null,
      completeOrder: null as IOrder | null,
      isMobile: isMobileOnly,
      disableTabs: true,
      selectedPlanType: '',
      isVoucherSettingsEnabled: false,
      planTypes: [] as any,
    };
  },
  computed: {
    ...mapGetters('auth', {
      merchantAccount: 'merchant',
    }),
    isVoucherEnabled() {
      return process.env.VOUCHERS_ENABLED === 'true';
    },
  },
  created() {
    this.isVoucherSettingsEnabled = this.merchantAccount?.voucherSettings?.active;
    this.planTypes = [...ORDER_TYPES];
    if (!this.isVoucherEnabled || !this.isVoucherSettingsEnabled) {
      this.selectedPlanType = 'PAYMENT_PLAN';
    }
  },
  methods: {
    setDone(id, next) {
      this[id] = true;
      if (next) {
        this.active = next;
      }
    },
    goBack() {
      this.setDone('created', 're');
    },
    nextToReview(order) {
      this.order = { ...order, flatFee: this.merchantAccount.flatFee, percFee: this.merchantAccount.percFee };
      this.setDone('created', 'review');
    },
    orderCreateDone(order) {
      this.order = { ...order, flatFee: this.merchantAccount.flatFee, percFee: this.merchantAccount.percFee };
    },
    orderReviewed(order) {
      this.completeOrder = _.clone(order);
      this.disableTabs = false;
      this.setDone('review', 'share');
    },
    orderDone() {
      this.$emit('close');
    },
    submitAndShare(order) {
      this.completeOrder = order;
      this.setDone('create', 'share');
    },
  },
});
